import styled from 'styled-components'

import { Box, Typography } from '@corabank/arco'

export const UploadContent = styled(Box)`
  @media screen and (max-width: 570px) {
    & {
      padding: 0 24px 24px;
    }
  }
`

export const UploadText = styled(Typography)`
  margin-left: 16px;
`
